<template>
    <div class="finance-coupon clearfix">
        <compWrapper theme="primary" title="基本信息">
            <compFormEdit
                ref="editForm"
                class="margin-layout"
                :col="1"
                v-model="formData"
                :formdata="getBase"
            ></compFormEdit>
        </compWrapper>
        <div class="pull-right">
            <Button type="primary" class="margin-right-5" @click="submit"
                >确定</Button
            >
            <Button @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpAddFuelSurcharge,
    HttpEditFuelSurcharge,
    HttpGetFuelSurcharge,
} from "@/service/fuelsurcharge";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    data() {
        return {
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
            formData: {},
            loading: false,
        };
    },
    async created() {
        if (this.type != "add") {
            await this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getCountryList"]),
        getBase() {
            return [
                {
                    label: "承运商:",
                    key: "carrierCode",
                    tag: "vSelect",
                    options: [
                        {
                            value: "FedEx",
                            label: "FedEx",
                        },
                        {
                            value: "UPS",
                            label: "UPS",
                        },
                    ],
                },
                {
                    label: "国家",
                    key: "country",
                    tag: "vSelect",
                    options: this.getCountryList.map((item) => {
                        return {
                            value: item.value,
                            label: item.value,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "燃油费率",
                    tag: "vInputNumber",
                    key: "fuelRate",
                    props: {
                        min: 0,
                    },
                },
                {
                    label: "生效开始时间:",
                    key: "beginTime",
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: "生效结束时间:",
                    key: "endTime",
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            await HttpGetFuelSurcharge({
                id: this.id,
            }).then(
                (res) => {
                    if (this.type == "edit") {
                        this.$refs.editForm.resetValidate();
                    }
                    this.formData = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        async submit() {
            await this.$refs.editForm.validate();
            this.loading = true;
            const RequestDate = {
                ...this.formData,
                orgId: global.SYSID,
            };
            // 添加
            if (this.type == "add") {
                await HttpAddFuelSurcharge(RequestDate).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-update");
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
            // 编辑
            else {
                await HttpEditFuelSurcharge(RequestDate).then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-update");
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
            this.loading = false;
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style></style>
